export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/verifiedSeller.4432bfc4.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};